const Category = () => (
  <h2>Under Construction</h2>
);

export default Category;
